import classNames from "classnames";

const Divider = ({ className }: { className?: string }) => {
  return <hr className={classNames("border-element-grey", className)} />;
};

export default Divider;
